import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import topTitle from '@/components/title';
import { tagsPlanResource, attachResource, mainDetailV2 } from './../request';
import { recursionCopy } from '@/views/customer/roleManage/utils';
import addPremiumModal from './addPremiumModal.vue';
import { quillEditor } from 'vue-quill-editor';
import quillConfig from '@/views/components/editor/quill-config.js';
import { AGELIST, PAYMENDEADLINE } from './../additionalFrom/utils';
export default {
  props: ['params', 'id', 'tableData', 'saveTagList'],
  components: {
    topTitle,
    addPremiumModal,
    quillEditor
  },
  data() {
    return {
      quillOption: quillConfig,
      disabled: false,
      dialogVisible: false,
      paymentDeadlineCont: '',
      paymentDeadline: undefined,
      dataFrom: {
        duration: {
          type: 1,
          value: ''
        },
        age: {
          type: 3,
          value: ''
        },
        hesitate: {
          type: 1,
          value: ''
        },
        wait: {
          type: 1,
          value: ''
        },
        healthNotice: '',
        areaPrice: {},
        attachInfo: [],
        generalHealthNotice: 'false',
        priceType: 'PRICE',
        isDefault: 0,
        generalTerms: 'false',
        rights: [{
          name: '',
          value: '',
          info: ''
        }],
        status: 1,
        insuranceTermsId: [0],
        sex: 0,
        socialSecurity: 0,
        paymentDeadline: {
          way: undefined,
          value: undefined,
          type: 1
        }
      },
      disabledLabel: true,
      paymentDeadlineType: 1,
      termlist: [{
        id: 1,
        name: '年(单值)'
      }, {
        id: 2,
        name: '年(范围)'
      }, {
        id: 3,
        name: '天(单值)'
      }, {
        id: 4,
        name: '天(范围)'
      }, {
        id: 5,
        name: '终身'
      }],
      AGELIST,
      PAYMENDEADLINE,
      duration1: '',
      duration2: '',
      age1: '',
      age2: '',
      tagsList: [],
      tagsSelectList: [],
      tagsAttributeList: [],
      attributeID: undefined,
      tagsType: undefined,
      tagObj: {
        fieldKey: '',
        fieldName: '',
        fieldValue: ''
      },
      continueAdd: false,
      additionalList: [],
      isTemplate: false,
      isSure: false,
      termsList: [],
      selectedTerms: [],
      attachInfo: [],
      premiumObj: {},
      editIndex: undefined,
      editStauts: false
    };
  },
  computed: {
    dataRule() {
      return {
        name: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('产品名称')
        }, {
          required: false,
          max: 20,
          message: this.$t('最多输入') + '20' + this.$t('字符'),
          trigger: 'change'
        }],
        price: [{
          required: true,
          trigger: 'blur',
          validator: this.validatePrice
        }],
        amount: [{
          required: true,
          trigger: 'blur',
          validator: this.validateAmount
        }],
        // socialSecurity: [{required: true, message: '请选择社保', trigger: 'change'}],
        // sex: [{required: true, message: '请选择性别', trigger: 'change'}],
        code: [{
          required: false,
          trigger: 'blur',
          validator: this.validateCode
        }],
        paymentDeadline: [{
          required: true,
          validator: this.validateDeadline,
          trigger: 'change'
        }],
        duration: [{
          required: true,
          trigger: 'change',
          validator: this.validateDuration
        }],
        age: [{
          required: true,
          trigger: 'change',
          validator: this.validateAge
        }],
        rights: [{
          required: true,
          trigger: 'change',
          validator: this.validateRights
        }],
        hesitate: [{
          required: false,
          trigger: 'change',
          validator: this.validatehesitate
        }],
        wait: [{
          required: false,
          trigger: 'change',
          validator: this.validateWait
        }],
        occupation: [{
          required: false,
          trigger: 'change',
          validator: this.validateOccupation
        }],
        tag: [{
          required: false,
          trigger: 'change',
          validator: this.validateTag
        }],
        remark: [{
          required: false,
          max: 50,
          message: this.$t('最多输入') + '50' + this.$t('字符'),
          trigger: 'change'
        }],
        unit: [{
          required: false,
          max: 10,
          message: this.$t('最多输入') + '10' + this.$t('字符'),
          trigger: 'change'
        }]
      };
    },
    isChina() {
      var _JSON$parse;
      let res = ((_JSON$parse = JSON.parse(sessionStorage.getItem('countryAndCurrencyInfo2'))) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.countryInfo.name) == '中国大陆';
      if (res) {
        return true;
      } else {
        return false;
      }
    }
  },
  async mounted() {
    attachResource(this.params).then(res => {
      this.additionalList = res;
      if (this.attachInfo.length) {
        let arr = this.filterHasAttach(this.attachInfo);
        this.attachInfo = arr;
      }
    });
    mainDetailV2({
      insuranceId: this.id
    }).then(res => {
      this.termsList = res.termsList;
    });
    if (this.saveTagList.length) {
      this.tagsList = this.saveTagList;
    } else {
      await this.getTagsResource();
    }
  },
  methods: {
    validateDuration(rule, value, callback) {
      if (this.dataFrom.duration.type != 5) {
        if (this.dataFrom.duration.type == 1 || this.dataFrom.duration.type == 3) {
          if (this.duration1 == '' || this.duration1 <= 0 || !this.duration1) {
            callback(new Error(this.$t('请输入') + this.$t('保障期限,仅限输入0以上数字')));
          } else if (String(this.duration1).charAt(0) == '.') {
            callback(new Error(this.$t('小数点不能为第一位')));
          } else if (String(this.duration1).indexOf('.') > -1) {
            if (String(this.duration1).split('.')[1].length > 2) {
              callback(new Error(this.$t('小数点之后保留两位')));
            }
          } else if (this.duration1 > 40000000) {
            callback(new Error(this.$t('不能大于40000000')));
          } else {
            callback();
          }
        } else {
          if (this.duration1 == '' || this.duration1 <= 0 || !this.duration1 || this.duration1 == '' || this.duration1 <= 0 || !this.duration1) {
            callback(new Error(this.$t('请输入') + this.$t('保障期限,仅限输入0以上数字')));
          } else if (String(this.duration1).charAt(0) == '.' || String(this.duration2).charAt(0) == '.') {
            callback(new Error(this.$t('小数点不能为第一位')));
          } else if (String(this.duration1).indexOf('.') > -1 || String(this.duration2).indexOf('.') > -1) {
            if (String(this.duration1).split('.')[1].length > 2 || String(this.duration2).split('.')[1].length > 2) {
              callback(new Error(this.$t('小数点之后保留两位')));
            }
          } else if (Number(this.duration1) > Number(this.duration2)) {
            callback(new Error(this.$t('最大值不能小于最小值')));
          } else if (Number(this.duration1) == Number(this.duration2)) {
            callback(new Error(this.$t('范围不能相同')));
          } else if (this.duration2 > 40000000) {
            callback(new Error(this.$t('不能大于40000000')));
          } else {
            callback();
          }
        }
      } else {
        callback();
      }
    },
    validateAge(rule, value, callback) {
      if (this.dataFrom.age.type == 1 || this.dataFrom.age.type == 2 || this.dataFrom.age.type == 3) {
        if (this.age1 == '' || this.age1 < 0 || !this.age1 || this.age2 == '' || this.age2 < 0 || !this.age2) {
          callback(new Error(this.$t('请输入') + this.$t('保障年龄,仅限输入0及以上整数')));
        }
        // else if (String(this.age1).charAt(0) == '.' || String(this.age2).charAt(0) == '.') {
        //   callback(new Error('小数点不能为第一位'));
        // }
        else if (String(this.age1).indexOf('.') > -1 || String(this.age2).indexOf('.') > -1) {
          // if (String(this.age1).split('.')[1].length > 2 || String(this.age2).split('.')[1].length > 2) {
          //   callback(new Error('小数点之后保留两位'));
          // }
          callback(new Error(this.$t('仅限输入整数')));
        } else if (Number(this.age1) > Number(this.age2)) {
          callback(new Error(this.$t('最大值不能小于最小值')));
        } else if (Number(this.age1) == Number(this.age2)) {
          callback(new Error(this.$t('范围不能相同')));
        } else if (this.age1 > 40000000 || this.age2 > 40000000) {
          callback(new Error(this.$t('不能大于40000000')));
        } else {
          callback();
        }
        console.log(this.age1, this.age2);
        callback();
      } else if (this.dataFrom.age.type == 4 || this.dataFrom.age.type == 5) {
        if (this.age1 == '' || this.age1 < 0 || !this.age1 || this.age2 == '' || this.age2 < 0 || !this.age2) {
          callback(new Error(this.$t('请输入') + this.$t('保障年龄,仅限输入0及以上数字')));
        }
        // else if (String(this.age1).charAt(0) == '.' || String(this.age2).charAt(0) == '.') {
        //   callback(new Error('小数点不能为第一位'));
        // }
        else if (String(this.age1).indexOf('.') > -1 || String(this.age2).indexOf('.') > -1) {
          // if (String(this.age1).split('.')[1].length > 2 || String(this.age2).split('.')[1].length > 2) {
          //   callback(new Error('小数点之后保留两位'));
          // }
          callback(new Error(this.$t('仅限输入整数')));
        } else if (this.age1 > 40000000 || this.age2 > 40000000) {
          callback(new Error(this.$t('不能大于40000000')));
        } else {
          callback();
        }
      } else {
        if (this.age1 == '' || this.age1 < 0 || !this.age1) {
          callback(new Error(this.$t('请输入') + this.$t('保障年龄,仅限输入0及以上数字')));
        }
        // else if (String(this.age1).charAt(0) == '.') {
        //   callback(new Error('小数点不能为第一位'));
        // }
        else if (String(this.age1).indexOf('.') > -1) {
          // if (String(this.age1).split('.')[1].length > 2) {
          //   callback(new Error('小数点之后保留两位'));
          // }
          callback(new Error(this.$t('仅限输入整数')));
        } else if (this.age1 > 40000000) {
          callback(new Error(this.$t('不能大于40000000')));
        } else {
          callback();
        }
      }
    },
    validateRights(rule, value, callback) {
      let arr = this.dataFrom.rights.findIndex(item => !item.name || !item.value);
      if (arr > -1) {
        callback(new Error(this.$t('请完善保障权益')));
      } else {
        // let arr1 = this.dataFrom.rights.findIndex(item => isNaN(Number(item.value)) || Number(item.value) <= 0);
        // let arr2 = this.dataFrom.rights.findIndex(item => String(item.value).charAt(0) == '.');
        // let arr3 = this.dataFrom.rights.findIndex(
        //   item => String(item.value).indexOf('.') > -1 && String(item.value).split('.')[1].length > 2
        // );
        // let arr4 = this.dataFrom.rights.findIndex(item => item.value > 40000000);
        // if (arr1 > -1) {
        //   callback(new Error(this.$t('保障金额仅限输入0以上的数字')));
        // } else if (arr2 > -1) {
        //   callback(new Error(this.$t('保障金额小数点不能为第一位')));
        // } else if (arr3 > -1) {
        //   callback(new Error(this.$t('保障金额小数点之后保留两位')));
        // } else if (arr4 > -1) {
        //   callback(new Error(this.$t('保障金额不能大于40000000')));
        // } else {
        //   callback();
        // }
        callback();
      }
    },
    validateDeadline(rule, value, callback) {
      if (this.paymentDeadline == 1) {
        if (!this.paymentDeadlineCont && this.paymentDeadlineCont !== 0) {
          callback(new Error(this.$t('请完善缴费期限')));
        } else if (Number(this.paymentDeadlineCont) > 99 || Number(this.paymentDeadlineCont) < 1) {
          callback(new Error(this.$t('请填写1-99范围内数字')));
        } else {
          callback();
        }
      } else if (this.paymentDeadline === 0) {
        callback();
      } else if (this.paymentDeadline == undefined) {
        callback(new Error(this.$t('请选择') + this.$t('缴费期限')));
      } else {
        callback();
      }
    },
    validatehesitate(rule, value, callback) {
      if (isNaN(this.dataFrom.hesitate.value) || Number(this.dataFrom.hesitate.value) < 0 || Number(this.dataFrom.hesitate.value) > 180) {
        callback(new Error(this.$t('请输入') + this.$t('0-180范围内数值')));
      } else if (Number(this.dataFrom.hesitate.value) % 1 !== 0) {
        callback(new Error(this.$t('请输入') + this.$t('0-180范围内整数')));
      } else if (String(this.dataFrom.hesitate.value).indexOf('.') > -1) {
        callback(new Error(this.$t('禁止输入小数点')));
      } else {
        callback();
      }
    },
    validateWait(rule, value, callback) {
      if (isNaN(this.dataFrom.wait.value) || Number(this.dataFrom.wait.value) < 0 || Number(this.dataFrom.wait.value) > 180) {
        callback(new Error(this.$t('请输入') + this.$t('0-180范围内数值')));
      } else if (Number(this.dataFrom.wait.value) % 1 !== 0) {
        callback(new Error(this.$t('请输入') + this.$t('0-180范围内整数')));
      } else if (String(this.dataFrom.wait.value).indexOf('.') > -1) {
        callback(new Error(this.$t('禁止输入小数点')));
      } else {
        callback();
      }
    },
    validatePrice(rule, value, callback) {
      if (!this.isTemplate) {
        if (!value) {
          callback(new Error(this.$t('请输入') + this.$t('保费,仅限输入0以上数字、小数点')));
        } else if (Number(value) < 0) {
          callback(new Error(this.$t('仅限输入0以上数字、小数点')));
        } else if (String(value).charAt(0) == '.') {
          callback(new Error(this.$t('小数点不能为第一位')));
        } else if (String(value).indexOf('.') > -1) {
          if (String(value).split('.').length != 2) {
            callback(new Error(this.$t('只能拥有一个小数点')));
          } else if (String(value).split('.')[1].length > 2) {
            callback(new Error(this.$t('小数点之后保留两位')));
          } else if (Number(value) > 40000000) {
            callback(new Error(this.$t('不能大于40000000')));
          } else {
            callback();
          }
        } else if (Number(value) > 40000000) {
          callback(new Error(this.$t('不能大于40000000')));
        } else {
          callback();
        }
      } else {
        callback();
      }
    },
    validateAmount(rule, value, callback) {
      if (!value) {
        callback(new Error(this.$t('请输入') + this.$t('保障金额,仅限输入0以上数字、小数点')));
      } else if (Number(value) < 0) {
        callback(new Error(this.$t('仅限输入0以上数字、小数点')));
      } else if (String(value).charAt(0) == '.') {
        callback(new Error(this.$t('小数点不能为第一位')));
      } else if (String(value).indexOf('.') > -1) {
        if (String(value).split('.').length != 2) {
          callback(new Error(this.$t('只能拥有一个小数点')));
        } else if (String(value).split('.')[1].length > 2) {
          callback(new Error(this.$t('小数点之后保留两位')));
        } else if (Number(value) > 40000000) {
          callback(new Error(this.$t('不能大于40000000')));
        } else {
          callback();
        }
      } else if (Number(value) > 40000000) {
        callback(new Error(this.$t('不能大于40000000')));
      } else {
        callback();
      }
    },
    validateCode(rule, value, callback) {
      if (!value) {
        callback();
      } else {
        if (value.length > 20 || value.length < 4) {
          callback(new Error('4-20' + this.$t('字符')));
        } else {
          callback();
        }
      }
      if (value < 0) {
        callback(new Error(this.$t('仅限输入0以上数字、小数点')));
      } else if (String(value).charAt(0) == '.') {
        callback(new Error(this.$t('小数点不能为第一位')));
      } else if (String(value).indexOf('.') > -1) {
        if (String(value).split('.')[1].length > 2) {
          callback(new Error(this.$t('小数点之后保留两位')));
        } else {
          callback();
        }
      } else {
        callback();
      }
    },
    validateOccupation(rule, value, callback) {
      if (value) {
        if (value.indexOf(',') == -1) {
          callback(new Error(this.$t('格式不对,例:1至N类，输入格式为1,n;N类，输入格式为n,n')));
        } else {
          const arr = value.split(',');
          if (/[^1-9]/g.test(arr[0])) {
            callback(new Error(this.$t('第一个值应该0以上数值')));
          } else if (/[^1-9]/g.test(arr[1])) {
            callback(new Error(this.$t('第二个值应该0以上数值')));
          } else if (value.split(',').length > 2) {
            callback(new Error(this.$t('格式不对,例:1至N类，输入格式为1,n;N类，输入格式为n,n')));
          } else {
            callback();
          }
          callback();
        }
      } else {
        callback();
      }
    },
    validateTag(rule, value, callback) {
      if (this.disabled) {
        if (this.tagObj.fieldValue || this.tagObj.fieldKey) {
          if (this.tagObj.fieldValue.length > 30 || this.tagObj.fieldKey.length > 30) {
            callback(new Error(this.$t('最多不超过') + '30' + this.$t('字符')));
          } else {
            callback(new Error(this.$t('请先保存标签')));
          }
        } else {
          callback(new Error(this.$t('至少输入') + '1' + this.$t('字符')));
        }
      } else {
        callback();
      }
    },
    init(val, id, i, isCopy) {
      this.editIndex = i;
      if (val) {
        var _data$insuranceTermsI;
        // mainPlanDetail({insurancePlanId: data.insurancePlanId}).then(res => {
        // console.log(val);
        let data = recursionCopy(val);
        data.code = data.code == '-' ? '' : data.code;
        if (isCopy) {
          data.id = undefined;
          data.insurancePlanId = undefined;
          data.name = undefined;
          data.code = undefined;
          data.isDefault = 0;
          data.status = 1;
          data.mark = undefined;
        }
        data.age = JSON.parse(data.age);
        // this.dataFrom = data;
        if (data.paymentDeadline === '0') {
          this.paymentDeadline = 0;
        } else {
          this.paymentDeadline = JSON.parse(data.paymentDeadline).way;
          this.paymentDeadlineType = JSON.parse(data.paymentDeadline).way != 0 ? JSON.parse(data.paymentDeadline).type : 1;
          this.paymentDeadlineCont = JSON.parse(data.paymentDeadline).way != 0 ? JSON.parse(data.paymentDeadline).value : undefined;
        }
        if (data.attachInfo) {
          data.attachInfo = JSON.parse(data.attachInfo);
        }
        data.rights = JSON.parse(data.rights);
        if (data.insuranceTermsId && (_data$insuranceTermsI = data.insuranceTermsId) !== null && _data$insuranceTermsI !== void 0 && _data$insuranceTermsI.split(',').length) {
          var _data$insuranceTermsI2;
          this.selectedTerms = (_data$insuranceTermsI2 = data.insuranceTermsId) === null || _data$insuranceTermsI2 === void 0 ? void 0 : _data$insuranceTermsI2.split(',');
        } else {
          this.selectedTerms = [];
        }
        // this.selectedTerms = data.insuranceTermsId ? data.insuranceTermsId?.split(',') : [0];
        this.isTemplate = data.priceType == 'AREA_PRICE' ? true : false;
        this.dataFrom.price = data.priceType == 'AREA_PRICE' ? undefined : data.price;
        if (data.areaPrice) {
          data.areaPrice = JSON.parse(data.areaPrice);
          Object.assign(this.premiumObj, data.areaPrice);
          this.getPremiumData(data.areaPrice);
        }
        this.attachInfo.splice(0);
        if (data.attachInfo && data.attachInfo.length) {
          this.filterHasAttach(data.attachInfo);
          this.attachInfo.push(...data.attachInfo);
        }
        if (data.duration.type == 2 || data.duration.type == 4) {
          this.duration1 = data.duration.value.split(',')[0];
          this.duration2 = data.duration.value.split(',')[1];
        } else if (data.duration.type == 5) {
          this.duration1 = '';
        } else {
          this.duration1 = data.duration.value;
        }
        if (data.age.type != 6 && data.age.type != 7 && data.age.type != 8) {
          this.age1 = data.age.value.split(',')[0];
          this.age2 = data.age.value.split(',')[1];
        } else {
          this.age1 = data.age.value;
        }
        this.tagsSelectList = data.tagsSort ? JSON.parse(data.tagsSort) : [];
        this.dataFrom = recursionCopy(data);
      } else {
        this.dataFrom.insuranceId = id;
        this.selectedTerms = [];
        this.dataFrom.insuranceTermsId = '';
      }
      this.dialogVisible = true;
    },
    templateRes() {
      let obj = recursionCopy(this.dataFrom.areaPrice);
      if (Object.keys(obj).length) {
        let price = obj.price.split(',');
        if (price.includes('undefined') || price.includes('null') || price.includes('')) {
          this.$message.warn(this.$t('请输入') + this.$t('区域保费'));
          this.$refs.templateRef.emitInfo();
          return false;
        } else {
          var _String, _String2;
          if (Number(price[0]) <= 0 || Number(price[1]) <= 0) {
            this.$message.warn(this.$t('区域保费仅限输入0以上数字'));
            return false;
          }
          if (String(price[0]).charAt(0) == '.' || String(price[1]).charAt(0) == '.') {
            this.$message.warn(this.$t('区域保费小数点不能为第一位'));
            return false;
          }
          if (((_String = String(price[0])) === null || _String === void 0 || (_String = _String.split('.')[1]) === null || _String === void 0 ? void 0 : _String.length) > 2 || ((_String2 = String(price[1])) === null || _String2 === void 0 || (_String2 = _String2.split('.')[1]) === null || _String2 === void 0 ? void 0 : _String2.length) > 2) {
            this.$message.warn(this.$t('区域保费小数点之后保留两位'));
            return false;
          }
          if (Number(price[0]) > 40000000 || Number(price[1]) > 40000000) {
            this.$message.warn(this.$t('区域保费不能大于40000000'));
            return false;
          }
          if (Number(price[0]) > Number(price[1])) {
            this.$message.warn(this.$t('区域保费最大值不能小于最小值'));
            return false;
          }
          if (Number(price[0]) == Number(price[1])) {
            this.$message.warn(this.$t('区域保费范围值不能相同'));
            return false;
          }
        }
        if (!obj.area || !obj.area.length) {
          this.$message.warn(this.$t('请添加区域保费数据'));
          return false;
        } else {
          var _obj$area;
          let isFind = obj === null || obj === void 0 ? void 0 : obj.area.find(i => !i.areaCode && i.areaCode !== '' || !i.areaCode.split(',').length || !i.price);
          let isOver = obj.area.find(i => Number(i.price) < Number(price[0]) || Number(i.price) > Number(price[1]) || Number(i.price) == 0);
          let valid1 = obj === null || obj === void 0 ? void 0 : obj.area.find(i => Number(i.price) <= 0);
          let valid2 = obj === null || obj === void 0 ? void 0 : obj.area.find(i => String(i.price).charAt(0) == '.');
          let valid3 = obj === null || obj === void 0 ? void 0 : obj.area.find(i => {
            var _String3;
            return ((_String3 = String(i.price)) === null || _String3 === void 0 || (_String3 = _String3.split('.')[1]) === null || _String3 === void 0 ? void 0 : _String3.length) > 2;
          });
          if (isFind) {
            this.$refs.templateRef.onSubmit();
            this.$message.warn(this.$t('请先完善保费数据'));
            return false;
          } else if ((obj === null || obj === void 0 || (_obj$area = obj.area) === null || _obj$area === void 0 ? void 0 : _obj$area.length) < 2) {
            this.$refs.templateRef.onSubmit();
            this.$message.warn(this.$t('请至少添加俩条保费数据'));
            return false;
          } else if (isOver) {
            this.$refs.templateRef.onSubmit();
            this.$message.warn(this.$t('输入保费不得超出保费范围'));
            return false;
          } else if (valid1) {
            this.$refs.templateRef.onSubmit();
            this.$message.warn(this.$t('区域保费仅限输入0以上数字'));
            return false;
          } else if (valid2) {
            this.$refs.templateRef.onSubmit();
            this.$message.warn(this.$t('区域保费小数点不能为第一位'));
            return false;
          } else if (valid3) {
            this.$refs.templateRef.onSubmit();
            this.$message.warn(this.$t('区域保费小数点之后保留两位'));
            return false;
          }
          return true;
        }
      } else {
        this.$refs.templateRef.emitInfo();
        this.$refs.templateRef.onSubmit();
        this.$message.warn(this.$t('请添加区域保费模版'));
        return false;
      }
      // let obj = {
      //   price: `${this.form.priceMin},${this.form.priceMax}`,
      //   area: this.templateData
      // };
      // this.$emit('premiumData', obj);
    },
    handleSure() {
      this.$refs.formRef.validate(valid => {
        if (valid) {
          if (this.disabled && this.tagObj.fieldValue && this.tagObj.fieldKey) {
            return this.$message.warn(this.$t('请先保存新增标签'));
          }
          if (this.isTemplate) {
            let res = this.templateRes();
            if (!res) {
              return;
            }
          }
          this.$refs.quanyiRef.validate(v => {
            if (v) {
              if (!this.selectedTerms.length && this.termsList.length) {
                return this.$message.warn(this.$t('请选择条款文件'));
              }
              this.saveSuccess();

              // if (this.dataFrom.generalHealthNotice == 'false' && !this.dataFrom.healthNotice) {
              //   return this.$message.warn('请选择或填写健康告知');
              // }
            }
          });
        }
      });
    },
    saveSuccess() {
      if (this.dataFrom.duration.type != 5) {
        this.dataFrom.duration.value = this.duration1;
        if (this.dataFrom.duration.type == 2 || this.dataFrom.duration.type == 4) {
          this.dataFrom.duration.value = this.duration1 + ',' + this.duration2;
        }
      }
      this.dataFrom.age.value = this.age1;
      if (this.dataFrom.age.type != 6 && this.dataFrom.age.type != 7 && this.dataFrom.age.type != 8) {
        this.dataFrom.age.value = this.age1 + ',' + this.age2;
      }
      let arr = this.dataFrom.rights.filter(item => item.name && item.value);
      this.dataFrom.rights = arr;
      if (this.tagsSelectList.length) {
        this.dataFrom.tagsSort = JSON.stringify(recursionCopy(this.tagsSelectList));
      } else {
        this.dataFrom.tagsSort = '';
      }
      this.dataFrom.sex = this.dataFrom.sex ? this.dataFrom.sex : 0;
      this.dataFrom.socialSecurity = this.dataFrom.socialSecurity ? this.dataFrom.socialSecurity : 0;
      console.log(this.paymentDeadline, 2222);
      if (this.paymentDeadline !== 0) {
        this.dataFrom.paymentDeadline = {
          way: 1,
          type: this.paymentDeadlineType,
          value: Number(this.paymentDeadlineCont)
        };
        // this.dataFrom.paymentDeadline.type = this.paymentDeadlineType;
      }
      let params = recursionCopy(this.dataFrom);
      if (this.selectedTerms.length) {
        params.insuranceTermsId = this.selectedTerms.join(',');
        if (this.selectedTerms.length == this.termsList.length) {
          params.generalTerms = 'true';
        } else {
          params.generalTerms = 'false';
        }
      } else {
        params.insuranceTermsId = '';
        params.generalTerms = 'true';
      }
      // params.duration = JSON.stringify(params.duration);
      params.age = JSON.stringify(params.age);
      params.attachInfo = typeof params.attachInfo == 'string' ? params.attachInfo : JSON.stringify(params.attachInfo);
      params.rights = typeof params.rights == 'string' ? params.rights : JSON.stringify(params.rights);
      params.paymentDeadline = typeof params.paymentDeadline == 'string' ? params.paymentDeadline : JSON.stringify(params.paymentDeadline);
      params.areaPrice = typeof params.areaPrice == 'string' ? params.areaPrice : JSON.stringify(params.areaPrice);
      params.id = params.id || new Date().getTime();
      this.$emit('getSavePlan', params, this.editIndex, this.continueAdd);
      if (this.continueAdd) {
        attachResource(this.params).then(res => {
          this.additionalList = res;
        });
      }
    },
    filterHasAttach(data) {
      let arr = [];
      data.map(item => {
        this.additionalList.map(add => {
          if (item.attachId == add.attachId) {
            arr.push(item);
          }
        });
      });
      return arr;
    },
    getAdditionalData(data) {
      this.dataFrom.attachInfo = data;
      console.log(data);
    },
    getClauseData(data) {
      this.selectedTerms = data;
      if (data.length == this.termsList.length) {
        this.dataFrom.generalTerms = 'true';
      } else {
        this.dataFrom.generalTerms = 'false';
      }
      this.dataFrom.insuranceTermsId = this.selectedTerms.join(',');
    },
    getPremiumData(data) {
      this.dataFrom.areaPrice = data;
      // this.isSure = false;
    },
    changeIsTemplate() {
      this.isTemplate ? this.$refs.formRef.clearValidate('price') : null;
      this.dataFrom.areaPrice = {};
      this.premiumObj = {};
      this.dataFrom.price = undefined;
      this.dataFrom.priceType = this.isTemplate ? 'AREA_PRICE' : 'PRICE';
    },
    addRightsFun() {
      this.$refs.quanyiRef.validate(v => {
        if (v) {
          this.dataFrom.rights.push({
            name: '',
            value: '',
            info: ''
          });
        }
      });
      // if(this.dataFrom.rights[this.dataFrom.rights.length=1])
    },
    async getTagsResource() {
      this.tagsList = await tagsPlanResource({});
    },
    delRightsFun(index) {
      this.dataFrom.rights.splice(index, 1);
      this.$refs.rights.onFieldChange();
    },
    changeHealthNotice() {
      this.dataFrom.generalHealthNotice = this.dataFrom.generalHealthNotice == 'true' || this.dataFrom.generalHealthNotice == true ? 'false' : 'true';
      this.dataFrom.healthNotice = '';
    },
    durationChange(type) {
      this[type] = String(this[type]).replace(/\D/g, '');
    },
    changeWait(type) {
      this.dataFrom[type].value = String(this.dataFrom[type].value).replace(/\D/g, '');
    },
    dataFormChange(type) {
      this.dataFrom[type] = String(this.dataFrom[type]).replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.');
    },
    onChange() {
      if (this.paymentDeadline == 0) {
        this.paymentDeadlineCont = '';
        this.dataFrom.paymentDeadline = {
          way: 0,
          type: 0,
          value: 0
        };
      } else {
        this.dataFrom.paymentDeadline = undefined;
      }
      this.$refs.paymentDeadline.onFieldChange();
    },
    changeNumber() {
      this.paymentDeadlineCont = String(this.paymentDeadlineCont).replace(/\D/g, '');
      this.$refs.paymentDeadline.onFieldChange();
      this.onInput();
    },
    onInput() {
      this.dataFrom.paymentDeadline = {
        way: 1,
        type: this.paymentDeadline,
        value: Number(this.paymentDeadlineCont)
      };
    },
    handleTagsChange(e) {
      if (this.tagsType || this.tagsType === 0) {
        this.disabledLabel = false;
      } else {
        this.disabledLabel = true;
      }
      let arr = this.tagsSelectList.filter(item => item.fieldKey == this.tagsList[e].fieldKey);
      if (arr.length != 0) {
        this.tagsAttributeList = [];
        this.tagsType = undefined;
        this.disabledLabel = true;
        return this.$message.error(this.$t('相同标签只能添加一个'));
      }
      this.attributeID = undefined;
      this.tagsAttributeList = this.tagsList[Number(e)].children;
    },
    handleTagsAttributeChange(e) {
      this.attributeID = undefined;
      this.tagsType = undefined;
      this.disabledLabel = true;
      // let arr = this.tagsSelectList.filter(
      //   item =>
      //     item.fieldKey + item.fieldValue == this.tagsAttributeList[e].fieldKey + this.tagsAttributeList[e].fieldValue
      // );
      let arr = this.tagsSelectList.filter(item => item.fieldKey == this.tagsAttributeList[e].fieldKey);
      if (arr.length != 0) {
        this.tagsAttributeList = [];
        return this.$message.error(this.$t('相同标签只能添加一个'));
      }
      this.tagsSelectList.push(this.tagsAttributeList[e]);
      this.tagsAttributeList = [];
    },
    handleClose(removedTag) {
      const tags = this.tagsSelectList.filter(tag => tag.fieldKey + tag.fieldValue !== removedTag.fieldKey + removedTag.fieldValue);
      this.tagsSelectList = tags;
    },
    async addTagSave() {
      if (!this.tagObj.fieldKey) {
        this.$message.error(this.$t('请输入') + this.$t('标签名称'));
        return false;
      }
      if (!this.tagObj.fieldValue) {
        this.$message.error(this.$t('请输入') + this.$t('标签属性名称'));
        return false;
      }
      let _valid = true;
      if (this.disabled && this.tagObj.fieldKey && this.tagObj.fieldValue) {
        _valid = true;
      } else {
        this.$refs.formRef.validateField('tag', valid => {
          if (valid) {
            _valid = false;
          } else {
            _valid = true;
          }
        });
      }
      if (_valid) {
        this.$refs.formRef.clearValidate('tag');
        // let res = this.tagsSelectList.find(
        //   i =>
        //     i.fieldKey == this.tagObj.fieldKey &&
        //     (i.fieldValue == this.tagObj.fieldValue || i.fieldFrontValue == this.tagObj.fieldValue)
        // );
        let res = this.tagsSelectList.find(i => i.fieldKey == this.tagObj.fieldKey);
        if (res) {
          return this.$message.error(this.$t('相同标签属性只能添加一个'));
        }
        let isHas = false;
        this.tagsList.map(item => {
          if (item.fieldKey == this.tagObj.fieldKey && item.children) {
            item.children.map(child => {
              if (child.fieldValue == this.tagObj.fieldValue || child.fieldFrontValue == this.tagObj.fieldValue) {
                isHas = true;
              } else {
                isHas = false;
              }
            });
          }
        });
        if (isHas) {
          return this.$message.error(this.$t('标签属性已存在，请选择分类'));
        }
        let isIndex = this.tagsList.findIndex(i => i.fieldKey === this.tagObj.fieldKey);
        if (isIndex > -1) {
          this.tagsList[isIndex].children.push({
            fieldKey: this.tagObj.fieldKey,
            fieldValue: this.tagObj.fieldValue,
            fieldFrontValue: this.tagObj.fieldValue
          });
        } else {
          let obj = {
            fieldKey: this.tagObj.fieldKey,
            children: [{
              fieldKey: this.tagObj.fieldKey,
              fieldValue: this.tagObj.fieldValue,
              fieldFrontValue: this.tagObj.fieldValue
            }]
          };
          this.tagsList.push(recursionCopy(obj));
        }
        this.tagsSelectList.push(recursionCopy(this.tagObj));
        this.$emit('tagList', recursionCopy(this.tagsList));
        // this.getTagsResource();
        this.disabled = false;
        this.tagObj.fieldKey = '';
        this.tagObj.fieldValue = '';
      }
    },
    resetForm() {
      this.$refs.formRef.resetFields();
      this.$refs.quanyiRef.resetFields();
      this.dataFrom.id = undefined;
      this.dataFrom.duration = {
        type: 1,
        value: ''
      };
      this.dataFrom.age = {
        type: 3,
        value: ''
      };
      this.dataFrom.hesitate = {
        type: 1,
        value: ''
      };
      this.dataFrom.wait = {
        type: 1,
        value: ''
      };
      this.dataFrom.healthNotice = '';
      this.dataFrom.areaPrice = {};
      this.dataFrom.premiumObj = {};
      this.dataFrom.price = undefined;
      this.dataFrom.amount = undefined;
      this.dataFrom.sex = 0;
      this.dataFrom.socialSecurity = 0;
      this.dataFrom.attachInfo = [];
      this.dataFrom.generalHealthNotice = 'false';
      this.dataFrom.priceType = 'PRICE';
      this.dataFrom.isDefault = 0;
      this.dataFrom.generalTerms = 'true';
      this.dataFrom.rights = [{
        name: '',
        value: '',
        info: ''
      }];
      this.dataFrom.status = 1;
      this.dataFrom.code = undefined;
      this.dataFrom.remark = undefined;
      this.dataFrom.paymentDeadline = {
        way: undefined,
        value: undefined,
        type: 1
      };
      this.paymentDeadline = undefined;
      this.paymentDeadlineType = 1;
      this.paymentDeadlineCont = '';
      this.age1 = undefined;
      this.age2 = undefined;
      this.duration1 = undefined;
      this.duration2 = undefined;
      this.tagsSelectList = [];
      this.selectedTerms = [];
      this.isTemplate = false;
      this.attachInfo = [];
      this.editIndex = undefined;
      if (this.continueAdd) {
        this.dataFrom.generalTerms = 'true';
        this.selectedTerms = this.termsList.map(i => i.insuranceTermsId);
        this.dataFrom.insuranceTermsId = this.selectedTerms.join(',');
        this.$refs.termsRef.form.clause = 0;
        this.$refs.termsRef.checkedAdditionalList = this.termsList.map(i => i);
      }
    }
  }
};